<template>
    <div class="grid-container" ref="edit-task-el">
        <div class="grid-item-left">
            <Textfield
                :innerRef="'edit_task_title'"
                v-model="task.title"
                :placeholder="'Add a task name...'"
                :inputClass="'mb-10'"
                :required="true"
                @focus="taskTitleOnCancel = task.title, $emit('textarea-blurred')"
                @blur="taskEditFieldNoLock('title', task.title)"
                class="task-title"
            />
            <TaskBody
                :task="task"
                :edit_modal_toggle="edit_modal_toggle"
                @taskEdit="taskEdit"
                :draggingBodyContent="draggingBodyContent"
                :cancelEditing="cancelEditing"
                @setCancelEditing="setCancelEditing"
                :lockingTask="lockingTask"
                @lockTask="lockTask"
                @updateTaskBody="updateTaskBody"
                @hiddenCancel="$emit('hiddenCancel')"
            />

            <div class="event-tabs">
                <EventsTabs
                    v-if="initActivitiesLoaded"
                    :loader="loadingActivities"
                    :users_tags="users_tags"
                    :task="task"
                    :tags="tags"
                    :showComment="true"
                    :fileUploaded="fileUploaded"
                    @searchActivity="searchActivity"
                    @updateTaskEvents="updateTaskEvents"
                    @hiddenCancel="$emit('hiddenCancel')"
                    :activitiesTitle="true"
                ></EventsTabs>
            </div>
        </div>

        <div class="grid-item-right" :key="task?.events?.length">
            <div class="top">
                <div class="flex-gap-9 title-wrap">
                    <i class="icon-time"></i>
                    <h2 class="component-title tags-title">Time Tracking</h2>
                </div>
                <TimeTrackerSmall :tags="tags" :events="task.events" :key="task.events?.length" />
                <LogWork :tags="tags" :task="task" @updateTaskEvents="updateTaskEvents"/>

                <div class="flex-gap-9 title-wrap">
                    <i class="icon-avatar"></i>
                    <h2 class="tags-title">Assigned</h2>
                </div>
                
                <TaskTags
                    :tags="tags"
                    :task="task"
                    taskPrefix="user"
                    @tagsUpdate="tagsUpdate"
                />

                <div class="flex-gap-9 title-wrap">
                    <i class="icon-tags"></i>
                    <h2 class="component-title tags-title">Tags</h2>
                    <a href="#" @click.prevent="showTagModal">
                        <i class="icon-edit edit-img"></i>
                    </a>
                </div>
                <TaskTags
                    :tags="allTags"
                    :task="task"
                    taskPrefix="tag"
                    @tagsUpdate="tagsUpdate"
                />

                <div class="flex-gap-9 title-wrap">
                    <i class="icon-actions"></i>
                    <h2 class="component-title tags-title">Actions</h2>
                </div>
                <UploadContainer class="uploader-edit-task" :id="task.id" @upload="fileUploaded"/>
            </div>
            <div class="right-bottom">
                <!-- <VButton 
                    :disabled="(!currentUserBoardRole.includes('owner') || !currentUserBoardRole.includes('admin')) && apiKey_search_arr.length === 0"
                    @clickHandler="$refs['api-key-modal'].showModal()"
                    fullWidth
                >
                    <i class="icon-clone-with-api"></i>
                    Clone with API
                </VButton> -->
                <VButton 
                    @clickHandler="$refs['archive-task-modal'].$refs['archive-task-modal'].showModal()"
                    fullWidth
                >
                    <i class="icon-archive-task"></i>
                    Archive Task
                </VButton>
            </div>
            <div class="bottom">

                <CustomCheckbox
                    :value="task.is_template"
                    @input="saveAsTemplate"
                    checkboxLabel="Make Template"
                    lablePosition="left"
                />
                <i class="icon-question-mark">
                    <Tooltip
                        size="large"
                        position="bc"
                    >
                        <div class="tooltip__label">When you mark a task as "template" it will be available where you click “+New Task” and will have the same task description.</div>
                    </Tooltip>
                </i>
            </div>
        </div>

        <Flash ref="show"/>
        
        <div class="hti-modal-wrap">
            <VModal 
                title="Clone with API"
                class="hti-modal"
                ref="api-key-modal"
                size="md"
                :flexheight="true"
            >
                <div class="hti-desc">
                    <p>You can make tasks from your own software. How it works is you have to <span class="p-blue-warn">make a token</span> and then afterwards you can see a code example using that token.</p>
                    <p>You then send that code example to your software developers and they will be able to make similar tasks as this one.</p>
                    <p><span class="p-orange-warn">WARNING</span>, anyone with the token will be able to make tasks on this board.</p>
                </div>
    
                <div class="hti-content">
                    <div v-if="apiKey_search_arr.length" class="hti-type-tabs">
                        <a href="#" @click.prevent="activeHTItab = 'cURL'" :class="['hti-type-tab', activeHTItab == 'cURL' ? 'active-hti-type-tab': '']">cURL</a>
                        <a href="#" @click.prevent="activeHTItab = 'Python'" :class="['hti-type-tab', activeHTItab == 'Python' ? 'active-hti-type-tab': '']">Python</a>
                        <a href="#" @click.prevent="activeHTItab = 'JavaScript'" :class="['hti-type-tab', activeHTItab == 'JavaScript' ? 'active-hti-type-tab': '']">JavaScript</a>
                        <!-- <a href="#" @click.prevent="activeHTItab = 'PHP'" :class="['hti-type-tab', activeHTItab == 'PHP' ? 'active-hti-type-tab': '']">PHP</a> -->
                    </div>
    
                    <div v-if="apiKey_search_arr.length" class="select-hti-type-wrapper">
                        <VSelect :options="apiKey_search_arr" :defaultFirstOption="true" value="key" title="name" @selectHandler="(val) => currentAPIKey = val">
                            <VButton 
                                v-if="currentUserBoardRole.includes('owner') || currentUserBoardRole.includes('admin')"
                                @clickHandler="$refs['add-new-token-modal'].showModal()"
                                :fullWidth="true"
                                class="add-new-token-btn"
                            >Add New Token</VButton>
                        </VSelect>
                    </div>
                    <div v-else>
                        No Token
                        <VButton 
                            v-if="currentUserBoardRole.includes('owner') || currentUserBoardRole.includes('admin')"
                            @clickHandler="$refs['add-new-token-modal'].showModal()"
                        >Add New Token</VButton>
                    </div>
                </div>
    
                <div v-if="apiKey_search_arr.length" class="sample-container">
                    <pre class="hti-desc">{{ apiKey_sample }}</pre>
                    <CopyBtn :value="apiKey_sample" />
                </div>
            </VModal>
        </div>

        <div class="new-token-wrap">
            <VModal 
                title="Add New Token"
                ref="add-new-token-modal"
                size="sm"
                :flexheight="true"
            >
                <form @submit.prevent="createAPIKey">
                    <label for="api-key-create">Token name</label>
                    <Textfield
                        id="api-key-create"
                        v-model="api_key_create_input"
                        :placeholder="'MyNewToken'"
                        :required="true"
                    />
        
                    <VButton 
                        @clickHandler="createAPIKey"
                        active
                    >Create</VButton>
                </form>
            </VModal>
        </div>

        <VModal ref="clipboard-modal" size="xl-pd-10" :flexheight="true">
            <ImageEditor @convertToBlob="convertToBlob" :clipboard_img="clipboard_img" :clipboardImageName="clipboardImageName" />
        </VModal>

        <ConfirmDelete
            ref="archive-task-modal"
            id="archive-task-modal"
            title="task"
            :archiveType="true"
            @delete="archiveTask()"
        />
        <VModal 
            title="New Tag"
            ref="edit-tag-modal"
            class="edit-tag-modal new-tag-modal"
            size="sm"
            :flexheight="true"
        >
            <label for="api-key-create">Tag name</label>
            <Textfield
                id="api-key-create"
                :placeholder="'New Tag'"
                :required="false"
                v-model="newTagName"
            />
            <div class="tag-editing-wrap"></div>
            <div class="d-flex tag-settings-block">
                <div class="w-33">
                    <span class="d-block">Colour</span>
                    <ColorSelector @color-selected="colorSelected"/>
                </div>
                <div class="w-33">
                    <span class="d-block">Icon</span>
                    <IconsSelector @icon-selected="iconSelected"/>
                </div>
                <label class="w-33"></label>
            </div>

            <VButton 
                @clickHandler="createTag"
                active
            >Create</VButton>
        </VModal>

    </div>
</template>
<script>
import {api} from "@/mixins/axios";
import {applyDrag, difference} from "@/mixins/helpers";
import Flash from "@/components/Flash.vue";
import VModal from "@/components/atoms/VModal.vue";
import VSelect from "@/components/atoms/VSelect.vue";
import ConfirmDelete from "@/components/organism/Confirm.vue";
import VButton from "@/components/atoms/VButton";
import LogWork from "@/components/organism/LogWork.vue";
import UploadContainer from "@/components/containers/UploadContainer.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import TextArea from "@/components/atoms/TextArea.vue";
import CopyBtn from "@/components/atoms/CopyBtn.vue";
import EventsTabs from "@/components/molecules/EventsTabs.vue";
import {mapGetters, mapMutations, mapState} from 'vuex';
import Dropmenu from "@/components/atoms/Dropmenu.vue";
import TaskTags from "@/components/molecules/TaskTags.vue";
import VCheckboxToggle from "@/components/atoms/VCheckboxToggle.vue";
import CustomCheckbox from "@/components/atoms/CustomCheckbox.vue";
import TimeTrackerSmall from "@/components/atoms/TimeTrackerSmall.vue";
import ImageEditor from "@/components/molecules/ImageEditor.vue";
import TaskBody from "@/components/molecules/TaskBody.vue";
import ScreenCast from "@/components/organism/ScreenCast.vue";
import Tooltip from "@/components/atoms/Tooltip.vue";
import ColorSelector from "@/components/atoms/ColorSelector.vue";
import IconsSelector from "@/components/atoms/IconsSelector.vue";
import LoaderAnimationVue from "@/components/atoms/LoaderAnimation.vue";

export default {
    name: "EditTask",
    components: {
        VButton,
        Flash,
        LogWork,
        UploadContainer,
        Textfield,
        TextArea,
        EventsTabs,
        Dropmenu,
        TaskTags,
        VCheckboxToggle,
        CopyBtn,
        VModal,
        ConfirmDelete,
        TimeTrackerSmall,
        VSelect,
        ImageEditor,
        TaskBody,
        ScreenCast,
        Tooltip,
        ColorSelector,
        IconsSelector,
        CustomCheckbox,
        LoaderAnimationVue,
    },
    props: ["board_id", "token", "tags", "board_id_from_task", "draggingBodyContent", "boardOverviewFunc"],
    data: function () {
        return {
            lostConnection: false,
            setAtags: [],
            setBtags: [],
            file: "",
            cacheTimerRenewLock: null,
            searchTag: "",
            lock: "",
            edit_modal_toggle: false,
            is_template: false,
            clearTimeOutEditTask: null,
            api_key_create_input: '',
            apiKey_search_arr: [],
            currentAPIKey: '',
            currentUserBoardRole: [],
            taskTitle: '',
            cancelEditing: false,
            taskTitleOnCancel: '',
            editingBody: false,
            lockingTask: false,
            unlockingTask: true,
            clipboard_img: '',
            clipboard_img_blob: null,
            clipboardImageName: 'file',
            activeHTItab: 'cURL',
            users_tags: null,
            clickedOutside: false,
            supportsReadNavigator: false,
            loadingActivities: false,
            isRecordingTask: 'inactive',
            bodyContentOnCancel: null,
            newTagColor: null,
            newTagName: null,
            newTagIcon: null,
            initActivitiesLoaded: false,
        };
    },
    computed: {
        apiKey_sample() {
            if (this.activeHTItab === 'cURL') {
                return `curl 'https://${location.host !== 'goleko.com' ? '1.' : ''}goleko.com/api/apikey_new_task' \\
                -H 'content-type: application/json' \\
                -H 'authorization: Bearer ${this.currentAPIKey}' \\
                --data-raw '{"list_id":${this.task.list_id},"title": "${this.task.title}", "tags": "|${this.task.tags?.map(e => `${e.tagType}:${e.id}`).join('|')}|", "body": "${this.convertBody(this.task.body)}"}' \\
                --compressed`
                    } else if (this.activeHTItab === 'Python') {
                        return `from requests import post

                url = "https://${location.host !== 'goleko.com' ? '1.' : ''}goleko.com/api/apikey_new_task"

                data = {
                    "list_id": ${this.task.list_id},
                    "title": "${this.task.title}",
                    "tags": "|${this.task.tags.map(e => `${e.tagType}:${e.id}`).join('|')}|",
                    "body": "${this.convertBody(this.task.body)}",
                }

                response = post(url, json=data, headers={"Authorization": f"Bearer ${this.currentAPIKey}"})

                if response.status_code == 200:
                    print("Task created successfully!")
                else:
                    print("Error:", response.status_code)
                    print("Message:", response.text)`
                            } else if (this.activeHTItab === 'JavaScript') {
                                return `fetch("https://${location.host !== 'goleko.com' ? '1.' : ''}goleko.com/api/apikey_new_task", {
                method: "POST",
                headers: {
                    "Authorization": "Bearer ${this.currentAPIKey}",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "list_id": ${this.task.list_id},
                    "title": "${this.task.title}",
                    "tags": "|${this.task.tags.map(e => `${e.tagType}:${e.id}`).join('|')}|",
                    "body": "${this.convertBody(this.task.body)}",
                })
                })
                .then((response) => response.json())
                .then((json) => console.log(json));`
            }
        },
        task() {
            return this.$store.getters.editableTask
        },
        currentUser() {
            return this.$store.getters.currentUser
        },
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        users() {
            return this.$store.getters.users
        },
        allTags() {
            return this.$store.getters.tags
        },
        isTaskEditing() {
			return this.$store.getters.isTaskEditing
		},
        uploadingInProcess() {
			return this.$store.getters.uploadingInProcess
		}
    },
    async mounted() {
        this.searchAPIKey()
        try {
            this.currentUserBoardRole = this.activeBoard.yourPerms.split('|').filter(i => i != '')
            this.users_tags = this.activeBoard.members
        } catch (e) {
            console.log(e);
        }

        this.$parent.$el.addEventListener('mousedown', (e) => {
            if (e.target.classList.contains('edit-task-modal')) {
                this.clickedOutside = true
            } else {
                this.clickedOutside = false
            }
        })

        window.addEventListener('paste', e => {
            if (!this.supportsReadNavigator) {
                this.handlePasteEvent(e)
            }
        })

        this.bodyContentOnCancel = JSON.parse(JSON.stringify(this.task.body))
        
        let owner = this.users.find(e => e.id == this.activeBoard.owner_id)
        this.$store.dispatch('setRecordingLimit', owner.max_record_time)

        if(this.uploadingInProcess == -1) {
            this.$store.dispatch('setUploadingState', null)
        }
    },
    async created() {
        // if (this.task && this.task.notify_me) {
        //     try {
        //         const data = {
        //             task_id: this.task.id,
        //         };
        //         const response = await api.post("/see_task_notifications", data);

        //         if (response.status === 200) {
        //             this.clearNotification(this.task)
        //             this.boardOverviewFunc()
        //         }
        //     } catch (e) {
        //         console.error(e);
        //     }
        // }

        //Is this really needed?
        // window.addEventListener('keydown', (e) => {
        //     if ((e.ctrlKey || e.metaKey) && e.key == 'v') {
        //         this.handlePasteFromClipboard(e)
        //     }
        // });

        window.addEventListener('beforeunload', (event) => {
            if (document.activeElement.parentElement.classList.contains('task-body')) {
                event.preventDefault()
                
                window.addEventListener('unload', function () {
                    this.unlockTask(true)
                });
                window.addEventListener('popstate', function () {
                    this.edit_modal_toggle = true
                    this.cancelEditing = false
                    this.unlockTask(true)
                });

                event.returnValue = 'Save or Cancel changes before leaving';
            }
        });

        await this.searchActivity(true)
    },
    methods: {
        async searchActivity(initLoad) {
            try {
                this.loadingActivities = true;
                
                const response = await api.post('/activity_search', {project_id: this.task.project_id, paginate_by: 1000, task_id: this.task.id})
                if (response.status === 200) {
                    let categories = ['logwork', 'upload', 'comment', 'edit_task_title', 'edit_task_body', 'move_task']
                    let events = response.data.data
                                .filter(e => e.task_id == this.task.id && categories.includes(e.type))
                                .map(e => ({
                                    ...e,
                                    unseen: e['unseen'].filter(item => item != `${this.currentUser.id}`)
                                }))
                    console.log(events)
                    //let task = JSON.parse(JSON.stringify(this.task))
                    this.$set(this.task, 'events', events)
                    this.loadingActivities = false;
                    this.$store.dispatch('setTaskEvents', this.task)

                    if(initLoad) {
                        this.initActivitiesLoaded = true
                    }

                    // console.log(this.task.events)
                    this.$forceUpdate()
                    this.$nextTick(() => {
                        if (this.isTaskEditing) {
                            console.log(document.querySelector('.task-body textarea'));
                            document.querySelector('.task-body textarea')?.focus()
                        }
                    })
                }
            } catch(e) {}
        },
        clearNotification(task) {
            // task.notify_me = false
            // const updatedTasks = this.tasks.map(originalTask => originalTask.id === task.id ? task : originalTask)
            // this.$store.dispatch('setTasks', JSON.parse(JSON.stringify(updatedTasks)))
        },
        convertBody(text) {
            if(!text) return text
            var step1 = text.replace(/"/g, '\\n');
            var finalText = step1.replace(/\n/g, '\\n');
            return finalText
        },
        renewLockTimer() {
            this.cacheTimerRenewLock = setInterval(() => {
                if (this.edit_modal_toggle && this.unlockingTask) {
                    this.renewLock();
                }
            }, 20000);
        },
        async saveAsTemplate(val) {
            this.task.is_template = val
            try {
                const data = {
                    id: this.task.id,
                    is_template: this.task.is_template,
                };
                const response = await api.post(`/task_edit`, data);

                if (response.status === 200) {
                    //this.$store.dispatch('saveAsTemplateTask', response.data.data);
                    this.$store.dispatch('toggleTemplateTask', response.data.data);
                    if (this.task.is_template) {
                        this.$refs.show?.showFlashSuccess('You can now duplicate this task in the + New Task (in the overview).');
                    }
                    return;
                }
            } catch (e) {
                console.error(e);
            }
        },
		async unlockTask(canceled) {
			if (!this.task.id) {
				return
			}
			try {
				let data = {
					id: this.task.id,
				};
                this.unlockingTask = false
				const response = await api.post(`/task_unlock`, data);
                if (response.data.msg === 'ok') {
                    this.edit_modal_toggle = false
                    this.lock = ''
                    this.unlockingTask = true
                    clearInterval(this.cacheTimerRenewLock)
                    if (canceled) return

                    this.$refs.show?.showFlashSuccess('Task description updated.');
                }

			} catch (e) {
				console.error(e);
			}
		},
        saveOnOutsideClick(editModal) {
            this.taskEdit(false, false, editModal)
        },
        dontSaveOnOutsideClick(editModal) {
            this.cancelEditing = true
            this.taskEdit(false, false, editModal)
        },
        async taskEdit(funcKeyPressed, bodyContentOnCancel, editModal) {
            if (!document.hasFocus() || funcKeyPressed) {
                this.lockingTask = false
                this.edit_modal_toggle = true
                return
            }
            
            if (this.cancelEditing) {
                await this.unlockTask(true)
                this.task.body = bodyContentOnCancel || this.bodyContentOnCancel
                this.cancelEditing = false
                if (editModal) editModal.hideModal()
                return
            }

            if (!api.online) {
                this.$refs.show.showFlashWarning("Lost connection, can't guarantee saving");
                return;
            }

            // let set_remove_tags = difference(this.setAtags, this.setBtags);
            // let set_add_tags = difference(this.setBtags, this.setAtags);
            // set_remove_tags = [...set_remove_tags];
            // set_add_tags = [...set_add_tags];

            const {id, tags, body} = this.task;
            // this.setBtags = tags;

            const data = {
                id,
                body,
                lock_id: this.lock
            };
            try {
                this.$refs.show.showFlashWarning('Updating task description...');
                const response = await api.post(`/task_edit_body`, data);
                if (response.data.data) {
                    this.$store.dispatch('setTaskEditing', false)
                    this.task.body_html = response.data.data.body_html
                    this.bodyContentOnCancel = response.data.data.body

                    this.$store.dispatch('editTaskDescription', response.data.data)
                    this.$store.dispatch('editTaskEvents', response.data.data)
                    this.searchActivity()

                    if(response.data.data.is_template) {
                        this.$store.dispatch('editTemplateTask', response.data.data)
                    }
                    await this.unlockTask()

                    if (editModal) editModal.hideModal()
                }

                if (response.data.msg === "ok") {
                    // TODO update task data inside modal
                    this.$emit('textarea-blurred')
                }
            } catch (e) {
                console.log(e)
                // if some one else locked while you didn't have internet
                this.$refs.show.showFlashWarning(e?.response?.data?.msg || e?.message);
                if (e.response.data.msg === "Expired Lock") {
                    this.$emit('hideModal')
                }
            }
        },
        async taskEditFieldNoLock(field, value) {
            if (this.task.title === this.taskTitleOnCancel) return

            if (this.cancelEditing) {
                this.task.title = this.taskTitleOnCancel
                this.cancelEditing = false
                return
            }
            
            if (!api.online) {
                this.$refs.show.showFlashWarning(
                    "Lost connection, can't guarantee saving",
                );
                return;
            }

            const data = {
                id: this.task.id,
                [field]: value,
            };
            
            this.$store.dispatch('editTask', this.task)
            if(this.task.is_template) {
                this.$store.dispatch('editTemplateTask', this.task)
            }

            try {
                const response = await api.post(`/task_edit`, data);
                if (response.data.msg === 'ok') {
                    //if (this.$route.name == 'SmartList') this.boardOverviewFunc()
                    this.$emit('textarea-blurred')
                    this.taskTitleOnCancel = ''
                }
            } catch (e) {
                console.error(e);
            }
        },
        async renewLock() {
            if (!this.lock) return;
            if (this.edit_modal_toggle === false) return;

            const {id} = this.task;
            const data = {
                id,
                seconds: 30,
                lock_id: this.lock,
            };

            try {
                const response = await api.post(`/task_renew_lock`, data);
                if (response.data.msg == 'ok') {
                    this.lock = response.data.lock
                }
            } catch (e) {
                console.error(e);
                clearInterval(this.cacheTimerRenewLock);
                if (!api.online) {

                    this.lostConnection = true;
                    this.$refs.show.showFlashWarning(
                        "Lost connection, can't guarantee saving",
                    );
                }
            }
        },
        async lockTask(event) {
            if (!api.online) {
                this.$refs.show.showFlashWarning(
                    "Lost connection, can't guarantee saving",
                );
                return;
            }
            const {id} = this.task;
            const data = {id, seconds: 30};

            let clickedText;

            if (event.target.classList.contains('task-body-html')) {
                const currentX = event.clientX;
                const currentY = event.clientY;

                const newX = currentX;
                const newY = currentY + 30;

                const elementAtPoint = document.elementFromPoint(newX, newY);

                if (elementAtPoint) clickedText = elementAtPoint.innerText
            } else {
                clickedText = event.target.innerText
            }

            try {
                this.lockingTask = true
                const response = await api.post(`/task_lock`, data);

                if (response?.data?.msg === "ok" && response?.data?.lock) {
                    this.lock = response.data.lock;

                    this.lockingTask = false
                    this.edit_modal_toggle = true
                    this.$nextTick(() => {
                        if (document?.querySelector('.task-body textarea.textarea')) {
                            const textarea = document?.querySelector('.task-body textarea.textarea')
                            textarea.focus();

                            const lines = this.task.body.split('\n')
                            let lineIndex = -1;
                            for (let i = 0; i < lines.length; i++) {
                                if (lines[i].includes(clickedText)) {
                                    lineIndex = i;
                                    break;
                                }
                            }
                            if (lineIndex >= 0) {
                                const lineHeight = textarea.scrollHeight / lines.length;
                                textarea.scrollTop = lineIndex * lineHeight - 100;
                                const linePosition = lines.slice(0, lineIndex).join('\n').length + lineIndex;
                                textarea.setSelectionRange(linePosition, linePosition);
                            }

                        } else {
                            this.unlockTask()
                            return
                        }
                    })

                    this.renewLockTimer();
                }
            } catch (e) {
                if (e.response?.data?.lock_user) {
                    clearInterval(this.cacheTimerRenewLock)
                    // TODO use user name instead
                    this.$refs.show.showFlashWarning(`Already locked by ${e.response.data.lock_user || "Unknown user"}`);
                } else {
                    this.$refs.show.showFlashError(e.response.data.msg);
                }
                this.$store.dispatch('setTaskEditing', false)
                this.edit_modal_toggle = false
                this.lockingTask = false
            }
        },
        async createAPIKey() {
            if(this.api_key_create_input?.trim() == '') {
                this.$refs.show.showFlashWarning('Empty text');
                return
            }
            const data = {
                project_id: this.task.project_id,
                name: this.api_key_create_input,
                perms: '|create_task|'
            }

            try {
                const response = await api.post(`/apikey_new`, data);

                if (response.data?.msg == 'ok') {
                    this.currentAPIKey = response.data.data.key
                    this.api_key_create_input = ''
                    this.$refs['add-new-token-modal'].hideModal()
                    this.searchAPIKey()
                }
            } catch (e) {
                console.log(e.response);
            }
        },
        async searchAPIKey() {
            const data = {
                project_id: this.board_id_from_task
            }
            
            try {
                const response = await api.post(`/apikey_search`, data);

                if (response.data?.msg == 'ok') {
                    this.apiKey_search_arr = response.data.data
                }
            } catch (e) {
                console.log(e.response);
            }
        },
        async archiveTask() {
            try {
                const response = await api.post(`/task_delete`, {id: this.task.id});

                if (response.data?.msg == 'ok') {
                    this.$store.dispatch('removeActiveBoardTask', this.task);
                    this.$emit('hideModal')
                }
            } catch (e) {
                this.$refs.show.showFlashError(e.response.data.msg)
            }
        },
        async handlePasteFromClipboard() {
            console.log('handlePasteFromClipboard')
            if (navigator?.clipboard?.read) {
                this.supportsReadNavigator = true
                const data = await navigator.clipboard.read()
                const clipboardContent = data[0]
                const type = clipboardContent.types[0]
                if (type == 'image/png') {
                    this?.$refs['clipboard-modal']?.showModal()
                    const blob = await clipboardContent.getType('image/png')
                    const url = window.URL.createObjectURL(blob)
                    this.getDataBlob(url)
                }
            }
        },
        async getDataBlob(url) {
			try {
				let res = await fetch(url)
				let blob = await res.blob()
				let uri = await this.parseURL(blob)
                
				this.clipboard_img = uri
                this.clipboard_img_blob = await this.blobToFile(blob);
			} catch (e) {
				this.$refs.show.showFlashError("Couldn't paste from clipboard")
			}
		},
        async parseURL (data) {
			let reader = new FileReader()
			reader.readAsDataURL(data)
			return new Promise((res, rej) => {
				reader.onload = e => {
					res(e.target.result)
				}
			})
		},
        uploadFromClipboard(files, id) {
            console.log('uploadFromClipboard')
            let taskID = id || this.task.id;
            console.log(this.$parent?.$parent)
            this.$parent?.$parent?.showUploadState(files, taskID)
            this?.$refs['clipboard-modal']?.hideModal()
            this.clipboardImageName = 'file'
            this.clipboard_img_blob = null
        },
        convertToBlob(canvas, file_name) {
            canvas.toBlob(async (blob) => {
                let uri = await this.parseURL(blob)
                
                this.clipboardImageName = file_name
                this.clipboard_img = uri
                this.uploadFromClipboard([await this.blobToFile(blob)])
            }, 'image/png')
        },
        async blobToFile(blob) {
            return new File([blob], `${this.clipboardImageName}.${blob.type.split('/')[blob.type.split('/').length - 1] || '.png'}`, { type: blob.type });
        },
        dataURLToBlob(dataURL) {
            const parts = dataURL.split(';base64,');
            const contentType = parts[0].split(':')[1];
            const byteString = atob(parts[1]);
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const uint8Array = new Uint8Array(arrayBuffer);

            for (let i = 0; i < byteString.length; i++) {
                uint8Array[i] = byteString.charCodeAt(i);
            }

            return new Blob([arrayBuffer], { type: contentType });
        },
        async fileUploaded(files, taskID) {
            console.log('fileUploaded')
            if(files.length == 1 && files[0].type.indexOf("image") >= 0) {
                let file = files[0]
                this.clipboardImageName = `Paste ${new Date().getFullYear()}.${(new Date().getMonth() + 1).toString().padStart(2, '0')}.${new Date().getDate().toString().padStart(2, '0')}`
                this?.$refs['clipboard-modal']?.showModal()

                let uri = await this.parseURL(file)
                this.clipboard_img = uri
                this.clipboard_img_blob = file
            } else if(files.length >= 1) {
                //this.clipboard_img_blob = file
                this.uploadFromClipboard(files, taskID)
            }
        },
        async handlePasteEvent(e) {
            console.log('handlePasteEvent')
            if (e?.clipboardData?.items.length > 0) {
                const data = e.clipboardData.items;
                const clipboardContent = data[0]
                const type = clipboardContent?.type
                this.clipboardImageName = `Paste ${new Date().getFullYear()}.${(new Date().getMonth() + 1).toString().padStart(2, '0')}.${new Date().getDate().toString().padStart(2, '0')}`
                
                if (clipboardContent.kind === "file" && type.indexOf("image") !== -1) {
                    this?.$refs['clipboard-modal']?.showModal()
                    const blob = clipboardContent.getAsFile();
                    const url = window.URL.createObjectURL(blob)
                    this.getDataBlob(url)
                } else if (clipboardContent.kind === "string" && clipboardContent.type === "text/html") {
                    const htmlData = e.clipboardData.getData('text/html');
                    
                    if (!htmlData.includes('<img')) return

                    const div = document.createElement('div')
                    div.innerHTML = htmlData
                    document.body.appendChild(div)
                    const img = div.lastElementChild
                    img.setAttribute('crossorigin', 'Anonymous')

                    img.onload = (e) => {
                        const canvas = document.createElement('canvas');
                        canvas.width = img?.width;
                        canvas.height = img?.height;
                        const ctx = canvas.getContext('2d');
                        
                        ctx.drawImage(img, 0, 0, img.width, img.height);
                        const imageDataURL = canvas.toDataURL('image/png');
                        let blob = this.dataURLToBlob(imageDataURL)
                        
                        try {
                            document.body.appendChild(canvas)
                            this?.$refs['clipboard-modal']?.showModal()

                            this.clipboard_img = imageDataURL
                            this.clipboard_img_blob = this.blobToFile(blob);

                            div.style.display = 'none'
                            canvas.style.display = 'none'
                        } catch(e) {
                            console.log(e)
                            div.style.display = 'none'
                            canvas.style.display = 'none'
                            this.$nextTick(() => this?.$refs['clipboard-modal']?.hideModal())
                        }
                    }
                }

                this.supportsReadNavigator = false
            }
        },
        setCancelEditing() {
			this.$store.dispatch('setTaskEditing', false)
            this.edit_modal_toggle = false;
            this.cancelEditing = true
        },
        updateTaskBody(data) {
            this.task.body = data.body
            this.task.body_html = data.body_html
        },
        showTagModal() {
            this.$refs['edit-tag-modal'].showModal()
        },
        async createTag() {
            if(!this.newTagName) {
                this.$refs.show.showFlashError('Please insert tag name')
                return 
            }
            if(!this.newTagColor) {
                this.$refs.show.showFlashError('You\'re missing color')
                return 
            }
            if(!this.newTagIcon) {
                this.$refs.show.showFlashError('You\'re missing icon')
                return 
            }

            if(this.allTags.find(t => t.name == this.newTagName)) {
                this.$refs.show.showFlashError('Tag with the same name already exists')
                return 
            }

            try {
                let data = {
                    name: this.newTagName,
                    project_id: this.task.project_id
                };

                if(this.newTagColor) {
                    data['color'] = this.newTagColor
                }

                if(this.newTagIcon) {
                    data['symbol'] = this.newTagIcon
                }

                const response = await api.post(`/tag_new`, data);

                if(response.status === 200) {
                    this.newTagName = null
                    this.newTagColor = null
                    this.newTagIcon = null
                    this.$store.dispatch('addTag', response.data.data)
                    this.$refs['edit-tag-modal'].hideModal()
                }
            } catch (e) {
                console.log(e);
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message )
            }
        },
        colorSelected(val) {
            this.newTagColor = val
        },
        iconSelected(val) {
            this.newTagIcon = val
        },
        updateTaskEvents() {
            this.$forceUpdate()
        },
        tagsUpdate() {
            this.$emit('textarea-blurred')
            this.$emit('tagsUpdate')
        },
    },
    watch: {
        uploadingInProcess(newVal) {
            if(newVal == -1) {
                this.$store.dispatch('setUploadingState', null)
                this.searchActivity()
            }
        }
    }
};
</script>

<style lang="scss">
/* file  preview size */

.grid-container {
    display: grid;
    gap: 20px;
    grid-template-columns: auto 306px;

    .hti-modal-wrap {
        .modal-backdrop .modal.light {
            max-width: 550px;
        }
        .hti-modal {
            display: block;
            .hti-desc {
                padding: 10px;
                background: #D9D9D91A;
                border-radius: 10px;
    
                p {
                    span {
                        &.p-blue-warn {color: #59C3FF;}
                        &.p-orange-warn {color: #FF8A00;}
                    }
                }
    
                p:last-of-type {
                    margin-bottom: 0;
                }
            }
    
            .hti-content {
                margin-top: 20px;
    
                .hti-type-tabs {
                    display: flex;
                    align-items: center;
                    gap: 10px;
    
                    .hti-type-tab {
                        background-color: #fff;
                        color: #000;
                        padding: 5px 10px;
                        border-radius: 5px;
    
                        &.active-hti-type-tab {
                            background-color: #4A9CCA;
                            color: #fff;
                        }
                    }
                }
    
                .select-hti-type-wrapper {
                    margin-top: 10px;
    
                    .add-new-token-btn {
                        color: #9BDBFF;
                        height: auto;
                        justify-content: flex-start;
                    }
                }
            }
        }
    }

    .new-tag-modal .modal{
        overflow: visible;

        .btn {
            height: 37px;
            padding-left: 20px;
            padding-right: 20px;
        }
    }

    .modal-backdrop .modal.light {
        border-radius: 10px;
        padding: 26px;

        .modal-header {
            margin-bottom: 0;
            h2 {
                margin-bottom: 10px;
            }
        }

        .modal-body {
            padding: 0;
        }
        label {
            display: block;
            color: #FFFFFFBF;
            margin-bottom: 5px;
        }
        input.textfield {
            padding: 7px;
        }
    }
}
.clipboard.modal {
    padding: 10px !important;

    .modal-header {
        display: none;
    }
}

.grid-item-left {
    grid-column: span 1;
    padding-right: 20px;

    .save-task-edit-btn, .cancel-task-edit-btn {
        margin-top: 5px;
        width: 80px;
        height: 30px;
    }
    .cancel-task-edit-btn { margin-left: 5px; }
}

.events-tab {
    grid-column: 1 / 2;
}

.event-tabs {
    .title-wrap {
        justify-content: space-between;

        i {
            font-size: 20px;
        }
    }

    .textarea {
        min-height: 81px;
        margin-bottom: 5px;
    }
}

.min-height-134{
    min-height: 134px;
}

.grid-item-right {
    vertical-align: top;

    grid-column: 2 / -1;
    grid-row: 1;
    
    .edit-img {
        cursor: pointer;
        display: block;
    }

    .top {
        .title-wrap {
            margin-top: 10px;
            margin-bottom: 10px;
        }
    }
}

.right-bottom {
    .btn {
        margin-bottom: 10px;
    }

    .btn.light:hover {
        svg {
            fill: #fff;
        }
    }

    i {
        margin-right: 7px;
    }
}

.bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;

    .checkbox-toggle .fake-label {
        font-weight: 700;
        color: #FFFFFFB0;
    }
}
@media screen and (max-width: 425px) {
    .modal {
        padding: 10px !important;
    }
}

@media (max-width: 778px) {
    .grid-container {
        grid-template-columns: 1fr;
    }
    .grid-item-right {
        grid-column: 1;
        grid-row: 2;
    }

    .grid-item-left {
        border-right: none;
        padding-right: 0px;
    }
    
    .modal-backdrop.edit-task-modal {
        .modal {
            .quick-time-btns .btn {
                width: 23%;
            }
        }
    }
    .task-body-container .task-body-html {
        max-width: 100% !important ;
    }
    .search-filter-wrap {
        margin-top: 0;
    }
}

.edit-tag-modal {
    .modal {
        overflow: unset;

        .icon-selector-wrap .icon-dropdown {
            width: 233px;
            height: 208px;
            overflow-y: auto;
        }
    }
}

.tags-search-results {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    z-index: 2;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 0.5rem;
    padding: 0.625rem;
    width: 100%;
}

.task-body-html h2 {
    font-size: 24px;
    font-weight: 400;
}

.task-title input.textfield {
    background: var(--secondary-bg);
    color: var(--primary-text);
    font-size: 1.6rem;
    padding: 10px 12px;
    border: none;
    border-radius: 6px;
    outline: none;
    width: 100%;
}

.sample-container {
    position: relative;
    pre {
        padding: 20px;
        overflow-x: auto;
    }
}
#api-key-select {
    width: 100%;
    padding: 10px 15px;
}
.createAPIKEYform {
    margin-bottom: 10px;
}

code {
    display: block;
    margin-left: 16px;
    border-radius: 10px;
    background: var(--primary-bg);
    font-size: 16px;
    font-weight: 200;
    line-height: 24px;
    padding: 10px;
}

code.inline-code {
   border-radius: 6px;
   background: var(--primary-bg);
   color: var(--accent-text);
   padding: 3px 8px;
   margin: 0;
   width: fit-content;
   display: inline;
}

.task-body-container {
    //position: relative;
    font-weight: 300;
    font-size: 16px;
    line-height: 20.16px;
    background: var(--secondary-bg);
    overflow: auto;
    border-radius: 6px;
    min-height: 45px;
    margin-bottom: 5px;

    &.loading {
        &::before {
            background-color: rgba(0, 0, 0, 0.5);
        }
        &::after {
            left: 50%;
            transform: translate(-50%,-50%);
            width: 30px;
            height: 30px;
        }
    }

    .edit-text-body textarea {
        padding-right: 60px !important;
        max-height: 732px;
        min-height: 105px;
        overflow-y: auto !important;
    }
    
    .task-body-html {
        word-break: break-word;
        max-width: calc(100% - 60px);
        max-height: 732px;
        min-height: 120px;
        padding: 12px;

        h1 {
            font-weight: 400;
            font-size: 30px;
            line-height: 37.8px;

        }

        blockquote {
            position: relative;
            margin-left: 16px;
            padding-left: 18px;

            &:before, &:after {
                content: "";
                position: absolute;
                display: block;
                top: 0;
                left: 5px;
                width: 2px;
                height: 100%;
                background-color: #907ABF;
                border-radius: 6px;
            }

            &:after {
                left: 0px;
            }
        }

        &.disable-edit {
            pointer-events: none;
        }

        a {
            color: var(--accent);
            font-weight: 400;
        }

        pre {
            text-wrap: balance;
            white-space: break-spaces;
        }

        table {
            border: 1px solid #848484;
            border-spacing: 0;
            border-collapse: separate;
            border-radius: 3px;
            overflow: hidden;
            padding-bottom: 10px;
            margin-bottom: 10px;

            thead {
                th {
                    font-weight: 500;
                    border-bottom: 1px solid #848484;
                    padding: 5px;
                    &:not(:first-child) {
                        border-left: 1px solid #848484;
                    }
                    &:first-of-type {
                        padding-left: 15px;
                    }
                }
            }

            tbody {
                td {
                    font-weight: 300;
                    padding: 5px;
                    position: relative;
                    isolation: isolate;
                    &:first-of-type {
                        padding-left: 15px;
                    }
                    &:last-of-type {
                        padding-right: 15px;
                    }
                }
                tr:nth-child(even) {
                    td::before {
                        content: "";
                        position: absolute;
                        top: 50%;
                        left: 0;
                        width: 100%;
                        transform: translateY(-50%);
                        background: #7D8790;
                        height: 90%;
                        z-index: -1;
                    }
                    td:first-of-type {
                        &::before {
                            border-radius: 6px 0 0 6px;
                            width: calc(100% - 10px);
                            right: 0;
                            left: 10px;
                        }
                    }
                    td:last-of-type {
                        &::before {
                            border-radius: 0 6px 6px 0;
                            left: 0;
                            width: calc(100% - 10px);
                        }
                    }
                }
                
            }
        }

        ul {
            padding-left: 0;
            li {
                margin-left: 16px;
                list-style: none;
                &::before {
                    content: '';
                    display: inline-block;
                    width: 4px;
                    height: 4px;
                    margin-right: 10px;
                    margin-bottom: 2px;
                    border-radius: 1px;
                    background: #CFCFCF;
                }

                p {
                    display: inline;
                }
                
                &.li-checkbox {
                    margin-left: 16px;
                    list-style-type: none;
                    &::before {
                        content: '';
                        display: none;
                    }
                    input {
                        margin-right: 5px;
                        width: 15px;
                        height: 15px;
                    }
                }
            }
        }
    }
}

.locking-task {
    font-size: 25px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    min-height: 200px;
}

.padding-0 {
    padding: 0;
}

.tag-settings-block {
    margin: 0 -5px 15px;

    .w-33 {
        padding: 0 5px;
    }
}

.upload-table {
    width: 100%;
    table-layout: fixed;

    th, td {
        padding: 5px;

        &:first-child {
            word-break: break-all;
            width: 70%;
        }

        &:last-child {
            width: 50px;
        }
    }
}

.hidden {
    opacity: 0;
    visibility: hidden;
    position: absolute;
}

.text-right {
    text-align: right;
}
</style>
